import {useCallback} from 'react';
import {srpFilterScreenNames} from './../../hotels-utils/src/get-details-navigation-id-and-values';
import {useStore, useDispatch} from 'react-redux';
import {useHistory, useLocation} from 'react-router-dom';
import {pushSearchesToApi} from '@growth/recent-search/helper';
import getSrpUrl from '@stencil/hotels-utils/src/get-srp-url';
import getDayUseSrpRouteUrl, {
  checkDayUseSRPVersionUnif,
} from '@stencil/hotels-utils/src/get-day-use-srp-route-url';
import getDayUseGoSuggestRouteUrl from '@stencil/hotels-utils/src/get-day-use-gosuggest-srp-url';
import {getLocusUrlParam} from '@stencil/hotels-utils/src/get-locus-url-string';
import {isNewFLowUrl, updateLocQueryParams} from '@stencil/hotels-utils/src/common-utils';
import {updateRecentSearch} from '@stencil/hotels-utils/src/recent-search-util';
import {
  resetNewCGFilterAction,
  updateAutosuggestOpenedBy,
  updateScrollToIdOnBack,
} from '@stencil/hotels-common-reducer/src/actions';
import {AutosuggestOpenedByPageType} from '@stencil/hotels-common-reducer/src/types';
import {GIPages} from '@stencil/hotels-types/src/hotels-types';
import {parse} from 'url';
import {apiConfig, lobName, tagIds} from '@stencil/hotels-config';
import {
  updateCalendarProgressiveSearchFormOpenedBy,
  updatePageHeaderSearchWidgetOpen,
} from '@stencil/hotels-common-reducer/src/actions';

import {
  commonSelector,
  isInternationalSelector,
  pokusDayUseMwebSRPRevampPageSelectorFn,
  pokusMwebSRPRevampPageSelectorFn,
  scrollToIdOnBackSelector,
  selectedPropertySelector,
} from '@stencil/hotels-common-reducer/src/selectors';
import {DETAIL_SEO_PAGES} from '@stencil/hotels-utils/src/seo-utils';
import getDetailsPageUrl from '@stencil/hotels-utils/src/get-details-page-url';
import {ScreenNamesType} from '@stencil/hotels-utils/src/get-details-navigation-id-and-values';
import getCgReviewPageUrl from '@stencil/hotels-utils/src/get-cg-review-page-url';

import querystring from 'query-string';
import {updateQueryAction} from '@stencil/hotels-common-reducer/src/actions';

import {
  routeToScreenMap,
  allDetailsScreens,
} from '@stencil/hotels-utils/src/get-details-navigation-id-and-values';
import {navigationMenuNames} from '@stencil/hotels-types/src/details-constants';

import {dayUseNavigationMenuNames} from '@stencil/hotels-utils/src/get-dayuse-navigation-id-and-values';
import splitRoomString from '@stencil/hotels-utils/src/split-room-string';
import {
  setCommonsRecentSearchData,
  setOldMwebCommonsRecentSearchData,
} from '@stencil/hotels-utils/src/recent-search-utils';
import {getReviewPageRoomCriteria, rescue} from '@stencil/hotels-utils/src/common-utils';
import {parseDate} from '@stencil/hotels-utils/src/date-utils/date-utils';

import {isValidRouteForCalendarAndTimeScreen} from '@stencil/hotels-utils/src/dayuse-common-utils';
import getDayUseDetailsPageUrl from '@stencil/hotels-utils/src/get-day-use-details-route-url';
import {updateDayUseSeoFlags} from '@stencil/hotels-day-use-srp-reducer/src/actions';
import {buildGoData} from '@stencil/hotels-utils/src/build-go-data-utils';
import useResetDetailsData from './useResetDetailsData';
import {isGpayMicroapp} from '@stencil/hotels-utils/src/common-utils';
import {
  resetSRPCGReducerAction,
  updateSRPCgConfig,
  resetSRPCGWithFilterResetReducerAction,
} from '@stencil/hotels-cg-reducer/src/srp/actions';
import {getNewUrl} from '@stencil/hotels-utils/src/get-new-flow-url';
import useQuery from './useQuery';

const appendSlashAtEnd = (s: string) => {
  if (typeof s !== 'string') return;
  return s.endsWith('/') ? s : `${s}/`;
};

const getArgsForDetailsUrlMake = ({
  selectedHotel,
  hotelPartner,
  checkinJSDate,
  checkoutJSDate,
  roomString,
  countryCode,
  cityName,
  metaPartner,
  locus,
  destination,
  appliedFiltersUniFormat,
  newFilterData,
  newLocationData,
  sortData,
  selectedRatePlanIndex,
  isSrpAltAcco,
  topHtlId,
  funnelSouce,
  unifSrpFilterData,
  scrollToId = '',
  fcSlotId = '',
  sType = '',
}) => {
  const detailsPageMakingOptions = {
    hotelData: {
      hn: selectedHotel.propertyName,
      hc: selectedHotel.propertyId,
      ibp: selectedHotel.propertyVendor,
      hmd: selectedHotel.hmd,
      mmtId: selectedHotel.mmtId,
    },
    partner: hotelPartner,
    checkin: {
      date: checkinJSDate,
    },
    checkout: {
      date: checkoutJSDate,
    },
    roomString: roomString,
    cityMetaInfo: {
      coc: countryCode,
    },
    destination: {
      n: cityName,
    },
    cityName,
    locus,
    metaPartner,
    cityId: destination._id || selectedHotel?.vcid || '',
    srpContinuedFilters: {},
    appliedFilters: selectedHotel?.af,
    country: countryCode,
    newFilterData,
    newLocationData,
    sort: sortData,
    selectedRatePlanIndex: selectedRatePlanIndex,
    isSrpAltAcco,
    topHtlId,
    funnelSouce,
    unifSrpFilterData,
    scrollToId,
    fcSlotId,
    sType,
  };
  if (appliedFiltersUniFormat?.length) {
    detailsPageMakingOptions.appliedFiltersUniFormat = appliedFiltersUniFormat;
  }

  return detailsPageMakingOptions;
};

const getArgsForDayuseDetailsUrlMake = ({
  selectedHotel,
  hotelPartner,
  checkinJSDate,
  roomString,
  locus,
  countryCode,
  cityName,
  metaPartner,
  checkinTime,
  selectedSlotDuration,
  srpType,
  newFilterData = '',
  newLocationData = '',
  sortData = '',
  mmtId = '',
  scrollToId = '',
}) => {
  const detailsPageMakingOptions = {
    hotelData: {
      hn: selectedHotel.propertyName,
      hc: selectedHotel.propertyId,
      ibp: selectedHotel.propertyVendor,
      hmd: selectedHotel.hmd,
    },
    partner: hotelPartner,
    checkin: {
      date: checkinJSDate,
    },
    selectedSlotDuration,
    srpType,
    roomString: roomString,
    cityMetaInfo: {
      coc: countryCode,
    },
    destination: {
      n: cityName,
    },
    locus,
    metaPartner,
    cityId: selectedHotel?.vcid || '',
    srpContinuedFilters: {},
    checkinTime: checkinTime,
    newFilterData,
    newLocationData,
    sortData,
    mmtId,
    scrollToId,
  };

  return detailsPageMakingOptions;
};

type NavigateToArgType =
  | 'goibiboHome'
  | 'home'
  | 'back'
  | 'newurl'
  | 'autosuggest'
  | 'calendar'
  | 'progressiveSearchForm'
  | 'srp'
  | 'semSrp'
  | 'crmSrp'
  | 'filters'
  | 'locationFilters'
  | 'addOnRoute'
  | 'details'
  | 'review'
  | 'dayuse-calendar'
  | 'dayuse-checkintime'
  | typeof dayUseNavigationMenuNames.autosuggest
  | typeof dayUseNavigationMenuNames.checkinTime
  | typeof dayUseNavigationMenuNames.calendar
  | typeof dayUseNavigationMenuNames.home
  | typeof dayUseNavigationMenuNames.srp
  | typeof dayUseNavigationMenuNames.detail
  | typeof dayUseNavigationMenuNames.amenities
  | typeof dayUseNavigationMenuNames.goSuggest
  | 'myearning'
  | 'feedback-ugc';

export type AddOnRouteArgType = ScreenNamesType;

function massageUrlForAddon({url, addOnRoute}) {
  const detailsPageBaseUrlData = parse(url);

  const pathName = appendSlashAtEnd(detailsPageBaseUrlData.pathname);
  const newPathName = appendSlashAtEnd(`${pathName}${addOnRoute}`);
  const search = detailsPageBaseUrlData.search;
  const hash = detailsPageBaseUrlData.hash ? detailsPageBaseUrlData : '';

  return {url: `${newPathName}${search}${hash}`, pathName, search};
}

export type SourceOfTriggerType =
  | 'detailsSimilarProperties'
  | 'srpSimilarProperties'
  | AutosuggestOpenedByPageType['page'];

const useNavigator = () => {
  const history = useHistory();
  const store = useStore();
  const dispatch = useDispatch();
  const location = useLocation();
  const {allParams} = useQuery();

  const queryParams = new URLSearchParams(location?.search);

  const {resetDetailsCaller} = useResetDetailsData();

  const updateDayuseSeoViewMoreStatusCaller = useCallback(
    (isSEO, isSeoUnif) => {
      dispatch(updateDayUseSeoFlags({isSEO, isSeoUnif}));
    },
    [dispatch],
  );

  const navigateTo = ({
    target,
    addOnRoute,
    sourceOfTrigger,
    openOutOfApp = false,
    replaceRoute = false,
    openInNewTab = false,
    doNotSaveRs = false,
    url = '',
    queryParams = {},
    customData = {},
    routeData = {},
    isSrpAltAcco,
    goSuggestId = '',
    funnelSouce = '',
  }: {
    target: NavigateToArgType;
    addOnRoute?: AddOnRouteArgType;
    sourceOfTrigger?: SourceOfTriggerType;
    openInNewTab?: boolean;
    openOutOfApp?: boolean;
    replaceRoute?: boolean;
    url?: string;
    customData?: object;
    routeData?: object;
    doNotSaveRs?: boolean;
    isSrpAltAcco?: boolean;
    goSuggestId?: string;
    funnelSouce?: string;
    queryParams?: object;
  }) => {
    const state = store.getState();
    const commonState = commonSelector(state);
    const {srpUnif = {}, user, dayuseSrp, detailsUnif} = state;
    const {isLoggedIn, userInfo = {}} = user;
    const {srpConfig: srpUnifConfig} = srpUnif;
    const {
      srpConfig: dayuseSrpConfig,
      isSEO: isDayuseSeoSrp,
      isSeoUnif: isDayuseUnifSeoSrp,
    } = dayuseSrp || {};
    const {propertyId, propertyName} = selectedPropertySelector(state);
    const isInternational = isInternationalSelector(state);
    const srpVersionV2 = pokusMwebSRPRevampPageSelectorFn(state);
    const hourlyVersionV2 = pokusDayUseMwebSRPRevampPageSelectorFn(state);

    const searchText = allParams?.searchText || '';
    const scrollToId = scrollToIdOnBackSelector(state);

    let {
      checkin,
      checkout,
      roomString,
      dayUseCheckinDate,
      destination,
      locus,
      country,
      partner,
      metaPartner,
      selectedHotel,
      isPageHeaderSearchWidgetOpen,
      pokusExpData,
      checkinTime,
      newFilterData = '',
      newLocationData = '',
      sortData = '',
      topHtlId,
      sType,
    } = commonState;
    let pathName = appendSlashAtEnd(location.pathname);
    const {deeplink_url_flow = false} = pokusExpData || {};

    const isNewFlowOpen = isNewFLowUrl(location.pathname, partner);
    const haveLocus = !!(locus?.id && locus?.type);

    const isNewSrpFlow =
      haveLocus &&
      (isNewFlowOpen || (deeplink_url_flow && srpVersionV2) || customData?.isNewSrpFlow);
    const isNewHourlySrpFlow =
      haveLocus && (isNewFlowOpen || (deeplink_url_flow && hourlyVersionV2));
    const isNewDetailsFlow = haveLocus && isNewFlowOpen;

    if (!customData?.skipPartnerCheck) {
      if (country?.toUpperCase() !== 'IN' && partner !== 'hotels-international') {
        dispatch(
          updateQueryAction({
            partner: 'hotels-international',
          }),
        );
        partner = 'hotels-international';
      }

      if (country?.toUpperCase() == 'IN' && partner !== 'hotels') {
        dispatch(
          updateQueryAction({
            partner: 'hotels',
          }),
        );
        partner = 'hotels';
      }
    }

    if (target == 'home') {
      dispatch(resetNewCGFilterAction());
      partner = 'hotels';
    }

    switch (target) {
      case 'goibiboHome':
        window.open('https://www.goibibo.com/', '_self');
        break;
      case 'home':
        const homeUrl = Object.keys(queryParams).length
          ? `/${partner}/?${querystring.stringify(queryParams)}`
          : `/${partner}`;
        if (replaceRoute) history.replace(homeUrl);
        else history.push(homeUrl);
        break;
      case 'back':
        history.goBack();
        break;
      case 'newurl':
        if (openInNewTab) window.open(url);
        else window.open(url, '_self');
        break;
      case 'myearning':
        const myearningurl = `/hotels/myearning`;
        history.push(myearningurl);
        break;
      case 'autosuggest':
        if (sourceOfTrigger) dispatch(updateAutosuggestOpenedBy(sourceOfTrigger));
        dispatch(resetNewCGFilterAction());
        if (replaceRoute) history.replace(pathName + `search/` + location.search);
        else history.push(pathName + `search/` + location.search);
        break;

      case 'calendar':
        if (
          sourceOfTrigger &&
          [
            'srp',
            'semSrp',
            'crmSrp',
            'details',
            'home',
            'roomSelectionPage',
            DETAIL_SEO_PAGES.review,
            GIPages.NearMe,
          ].includes(sourceOfTrigger)
        ) {
          dispatch(updateCalendarProgressiveSearchFormOpenedBy(sourceOfTrigger));
          if (replaceRoute) history.replace(pathName + `calendar/` + location.search);
          else history.push(pathName + `calendar/` + location.search, routeData);
        }
        break;

      case 'progressiveSearchForm':
        if (
          sourceOfTrigger &&
          [
            'srp',
            'semSrp',
            'crmSrp',
            'details',
            'home',
            'roomSelectionPage',
            DETAIL_SEO_PAGES.review,
            GIPages.NearMe,
          ].includes(sourceOfTrigger)
        ) {
          dispatch(updateCalendarProgressiveSearchFormOpenedBy(sourceOfTrigger));
          if (replaceRoute)
            history.replace(pathName + `add-travellers/` + location.search, routeData);
          else history.push(pathName + `add-travellers/` + location.search, routeData);
        }
        break;

      case 'srp': {
        const {
          shouldEncode,
          newFilterData: propNewFilterData,
          newLocationData: propNewLocationData,
          newSelectedRegionCity,
          sort: propSort,
          isFilterChange,
        } = customData || {};
        const {metaPartner, overriderankvhids, isSeo: isSeoV2} = srpUnifConfig;
        const goSuggest = !!(overriderankvhids && metaPartner);

        if (isSeoV2) {
          dispatch(updateSRPCgConfig({isSeo: false}));
        }
        let finalDestination = goSuggest
          ? {...destination, mmtId: selectedHotel?.mmtId}
          : destination;
        let finalLocus = goSuggest
          ? {...locus, search: 'hotel', mmtId: selectedHotel?.mmtId}
          : locus;
        const data = {
          city: allParams?.city || '',
          searchText,
          checkin,
          checkout,
          roomString,
          destination: finalDestination,
          locus: finalLocus,
          country,
          partner,
          filter: {},
          shouldEncode,
          selectedRegionCity: newSelectedRegionCity,
          newFilterData: propNewFilterData || newFilterData,
          newLocationData: propNewLocationData || newLocationData,
          mmtId: topHtlId,
          sort: propSort || sortData,
          isSrpAltAcco,
          propertyName: selectedHotel?.propertyName,
          funnel: 'main',
          sType,
        };
        const srpUrl = isNewSrpFlow ? getNewUrl(data, 'srp') : getSrpUrl(data);
        if (!(sourceOfTrigger && sourceOfTrigger === 'details')) {
          if (isFilterChange) {
            dispatch(resetSRPCGWithFilterResetReducerAction({isFilterReset: true}));
          } else {
            dispatch(resetSRPCGReducerAction());
          }
        }
        // need to update a condition here for whether to track to recent search
        // if hits coming from FilterScreen, need not track into recent search
        const goSuggestHotel = goSuggest
          ? {hotelName: selectedHotel?.propertyName, hotelCode: selectedHotel?.propertyId}
          : {};
        updateRecentSearch({
          destination: finalDestination,
          locus: finalLocus,
          checkin,
          checkout,
          country,
          partner,
          roomString,
          ...goSuggestHotel,
        });

        rescue(() => {
          const {paxCount, roomCount, childCount, childAgeArray} = splitRoomString(roomString);
          const url = srpUrl;
          const str = !!destination?._id ? `hotel-${destination?._id}` : `hotel-${locus?.id}`;
          const cityId = destination?.ct?._id || destination?._id;
          const cityName = destination?.ct?.n || destination?.n;

          // goSuggestSRP-SRP
          const dynamicGoData = goSuggest
            ? {
                page: GIPages.Details,
                propertyId: selectedHotel?.propertyId,
                propertyName: selectedHotel?.propertyName,
              }
            : {
                page: GIPages.Srp,
              };
          const goData = buildGoData({
            cityId: cityId,
            cityName: destination?.n,
            destinationType: destination?.t,
            cityMetaEid: destination?._id,
            checkInDate: checkin,
            checkOutDate: checkout,
            roomString,
            locationData: propNewLocationData || newLocationData,
            countryCode: country,
            locus: finalLocus,
            mmtId: goSuggest ? selectedHotel?.mmtId : '',
            ...dynamicGoData,
          });
          if (doNotSaveRs) {
            return;
          }

          updateRecentSearch({
            destination: finalDestination,
            locus: finalLocus,
            checkin,
            checkout,
            country,
            partner,
            roomString,
            ...goSuggestHotel,
          });

          const dynamicRecentSearchData = goSuggest
            ? {
                tagId: tagIds.goSuggestSrp,
                name: propertyName,
                title: propertyName,
                subLob: 'hotel',
                type: 'hotel',
                hotelId: propertyId,
              }
            : {
                tagId: tagIds.srp,
                name: destination?.n,
                title: destination?.n,
                subLob: destination?.t,
                type: destination?.t,
              };
          const data = setCommonsRecentSearchData({
            godata: goData,
            adultCount: paxCount,
            childCount,
            childAgeArray,
            roomCount: roomCount,
            cityName,
            cityId,
            lobName: lobName,
            traveldate: new Date(checkin?.date),
            returnDate: new Date(checkout?.date),
            url,
            isInternational,
            countryCode: country,
            roomString,
            locus: finalLocus,
            ...dynamicRecentSearchData,
          });
          if (locus) {
            pushSearchesToApi({
              lobName,
              searchDetails: data,
              onPushSuccess: r => {},
              onPushFail: e => {
                console.log('pushSearchesToApi failed', e);
              },
            });
          }
          /* Old Support */
          const dynamicOldCRSData = goSuggest
            ? {
                tagId: tagIds.goSuggestSrp,
                name: propertyName,
                title: propertyName,
                source: propertyName,
                subLob: 'hotel',
              }
            : {
                tagId: tagIds.srp,
                name: destination?.n,
                title: destination?.n,
                source: destination?.n,
                subLob: destination?.t,
              };
          const oldMwebData = setOldMwebCommonsRecentSearchData({
            godata: goData,
            userId: isLoggedIn && userInfo?.profileId, //common
            destination: destination?.n,
            id: str,
            paxCount: paxCount + childCount,
            roomCount: roomCount,
            roomType: 'rooms',
            lobName: lobName,
            traveldate: new Date(checkin?.date).getTime(),
            returnDate: new Date(checkout?.date).getTime(),
            url,
            ...dynamicOldCRSData,
          });
        });

        isPageHeaderSearchWidgetOpen && dispatch(updatePageHeaderSearchWidgetOpen(false)); // close search widget on in-app movement
        if (openInNewTab) {
          window.open(srpUrl, '_blank');
        } else if (replaceRoute) history.replace(srpUrl, routeData);
        else history.push(srpUrl, routeData);
        break;
      }
      case 'details':
        {
          const checkinJSDate = checkin.date;
          const checkoutJSDate = checkout.date;
          const hotelPartner = partner;
          const cityName = customData?.cityName || destination.n;
          const {propertyId, propertyName} = selectedPropertySelector(state);
          const appliedFiltersUniFormat = detailsUnif.appliedFiltersInUrl;
          const fcSlotId = customData?.fcSlotId;
          const validateHotelData =
            customData?.propertyId && customData?.propertyName && customData?.mmtId
              ? customData
              : selectedHotel;

          const detailsUnifPageMakingOptions = {
            checkin,
            checkout,
            searchText,
            roomString,
            destination,
            locus,
            partner: hotelPartner,
            country,
            newFilterData: customData?.newFilterData || newFilterData,
            newLocationData: customData?.newLocationData || newLocationData,
            mmtId: selectedHotel?.mmtId || customData?.mmtId,
            propertyName: selectedHotel?.propertyName || customData?.propertyName,
            propertyId: selectedHotel?.propertyId || customData?.propertyId,
            fcSlotId,
            topHtlId,
            sType,
          };

          const detailsPageMakingOptions = getArgsForDetailsUrlMake({
            selectedHotel: validateHotelData,
            hotelPartner,
            checkinJSDate,
            checkoutJSDate,
            roomString,
            countryCode: country,
            cityName,
            metaPartner,
            locus,
            destination,
            appliedFiltersUniFormat,
            newFilterData,
            newLocationData,
            sortData,
            selectedRatePlanIndex: customData?.selectedRatePlanIndex,
            isSrpAltAcco,
            topHtlId,
            funnelSouce: funnelSouce || '',
            unifSrpFilterData: customData?.newFilterData,
            scrollToId: scrollToId || '',
            fcSlotId,
            sType,
          });

          // if (!allFirstLevelObjectKeysAreNonNullable(selectedHotel)) {
          //   return;
          // }

          if (
            !(selectedHotel?.propertyId || customData?.propertyId) ||
            !(selectedHotel?.propertyName || customData?.propertyName)
          ) {
            return null;
          }

          isPageHeaderSearchWidgetOpen && dispatch(updatePageHeaderSearchWidgetOpen(false)); // close search widget on in-app movement
          const detailsUrl = isNewDetailsFlow
            ? getNewUrl(detailsUnifPageMakingOptions, 'details')
            : getDetailsPageUrl(detailsPageMakingOptions);
          resetDetailsCaller();

          if (scrollToId) {
            dispatch(updateScrollToIdOnBack(''));
          }

          if (openInNewTab) {
            window.open(detailsUrl, '_blank');
          } else if (replaceRoute)
            history.replace(detailsUrl, {...routeData, viewTransition: true, flushSync: true});
          else history.push(detailsUrl, {...routeData, viewTransition: true, flushSync: true});
        }

        break;

      case 'review':
        {
          const {propertyId, propertyName} = selectedPropertySelector(state);
          const isGpayFunnel = isGpayMicroapp();

          let reviewUrl = '';

          const deskBlockInput = customData;
          const {rs: roomSelectionObject} = deskBlockInput;
          const locusParams = getLocusUrlParam(locus);
          const {roomCriteria, mtKey} = getReviewPageRoomCriteria(roomSelectionObject);
          reviewUrl = getCgReviewPageUrl(
            {
              _uCurrency: deskBlockInput?.currency || 'INR',
              checkin: parseDate(checkin?.date, 'mmddyyyy'),
              checkout: parseDate(checkout?.date, 'mmddyyyy'),
              city: deskBlockInput?.destination?.n,
              country,
              couponCode: deskBlockInput?.code,
              hotelId: detailsUnif?.searchRooms?.data?.hotelDetails?.hotelId,
              giHotelId: propertyId,
              lat: '',
              lng: '',
              locusId: locusParams?.locusId,
              locusType: locusParams?.locusType,
              mtKey: mtKey,
              payMode: deskBlockInput?.payModeNew,
              rank: '',
              regionNearByExp: '',
              roomCriteria: encodeURIComponent(roomCriteria),
              roomStayQualifier: '',
              searchText: deskBlockInput?.hotelName,
              searchType: deskBlockInput?.searchType,
              suppDetail: '',
              topHtlId,
              screenKey: '',
              vcid: deskBlockInput?.destination?._id,
              roomString: deskBlockInput?.roomString,
              luckyProperty: deskBlockInput?.luckyProperty?.toString(),
              filterData: newFilterData,
              locationData: newLocationData,
              sort: sortData,
              sType,
            },
            partner,
          );

          if (replaceRoute) history.replace(reviewUrl);
          else history.push(reviewUrl);
        }
        break;

      case 'feedback-ugc':
        {
          if (!addOnRoute) {
            throw new Error(`addOnRoute should be second parameter to navigateTo function`);
          }
          const navigationConfig = {
            congrats: {paramsToSet: {isFormDone: 'true'}, paramsToDelete: ['qna']},
            qna: {paramsToSet: {qna: 'true'}, paramsToDelete: ['isFormDone']},
            exp: {paramsToSet: {}, paramsToDelete: ['qna', 'isFormDone']},
          };
          const {paramsToSet, paramsToDelete} = navigationConfig[addOnRoute] || {};
          updateLocQueryParams(queryParams, paramsToSet, paramsToDelete);
        }
        break;

      case 'addOnRoute': {
        if (!addOnRoute) {
          throw new Error(`addOnRoute should be second parameter to navigateTo function`);
        }

        const appliedFiltersUniFormat = detailsUnif.appliedFiltersInUrl;
        const checkinJSDate = checkin.date;
        const checkoutJSDate = checkout.date;
        const hotelPartner = partner;
        const cityName = destination.n;
        let toBeProcessedUrl = '';
        const fcSlotId = customData?.fcSlotId;

        if (allDetailsScreens.indexOf(addOnRoute) > -1) {
          const detailsPageMakingOptions = getArgsForDetailsUrlMake({
            selectedHotel: commonState.selectedHotel,
            hotelPartner,
            checkinJSDate,
            checkoutJSDate,
            roomString,
            countryCode: country,
            cityName,
            metaPartner,
            locus,
            destination,
            appliedFiltersUniFormat,
            newFilterData,
            newLocationData,
            sortData,
            fcSlotId,
            topHtlId,
            sType,
          });

          const detailsUnifPageMakingOptions = {
            checkin,
            checkout,
            searchText,
            roomString,
            destination,
            locus,
            partner: hotelPartner,
            country,
            newFilterData: customData?.newFilterData || newFilterData,
            newLocationData: customData?.newLocationData || newLocationData,
            mmtId: selectedHotel?.mmtId,
            propertyName: selectedHotel?.propertyName,
            propertyId: selectedHotel?.propertyId,
            sortData,
            cityName,
            fcSlotId,
            topHtlId,
            sType,
          };

          toBeProcessedUrl = isNewDetailsFlow
            ? getNewUrl(detailsUnifPageMakingOptions, 'details')
            : getDetailsPageUrl(detailsPageMakingOptions, customData?.isDayUse);
        }
        if (
          [
            'filters',
            'locationFilters',
            'amenitiesFilter',
            srpFilterScreenNames.hotelSearch,
          ].indexOf(addOnRoute) > -1
        ) {
          const updatedFilters = {newFilterData, newLocationData, sortData};
          if (srpFilterScreenNames.hotelSearch === addOnRoute) {
            updatedFilters['newFilterData'] = '';
            updatedFilters['newLocationData'] = '';
            updatedFilters['sortData'] = '';
            dispatch(updateQueryAction({...updatedFilters}));
          }
          const data = {
            searchText,
            checkin,
            checkout,
            roomString,
            destination,
            locus,
            country,
            partner,
            funnel: 'main',
            filter: {},
            ...updatedFilters,
          };
          toBeProcessedUrl = isNewSrpFlow ? getNewUrl(data, 'srp') : getSrpUrl(data);
        }

        if (['hourlyFilterScreen'].indexOf(addOnRoute) > -1) {
          const url = pathName + `hourlyFilterScreen/` + location.search;
          if (replaceRoute) history.replace(url, routeData);
          else history.push(url, routeData);
          return;
        }

        if ([dayUseNavigationMenuNames.amenities].indexOf(addOnRoute) > -1) {
          const url = pathName + `hourly-amenitiesFilter/` + location.search;
          if (replaceRoute) history.replace(url, routeData);
          else history.push(url, routeData);
          return;
        }

        if ([dayUseNavigationMenuNames.locationFilter].indexOf(addOnRoute) > -1) {
          const url = pathName + `hourly-locationFilter/` + location.search;
          if (replaceRoute) history.replace(url, routeData);
          else history.push(url, routeData);
          return;
        }
        const parsedSearch = querystring.parse(history?.location?.search);
        if (parsedSearch?.appliedFilters && toBeProcessedUrl.indexOf('appliedFilters') < 0) {
          toBeProcessedUrl = toBeProcessedUrl + `&appliedFilters=${parsedSearch?.appliedFilters}`;
        }
        const {
          url: massagedUrl,
          pathName: pathNames,
          search,
        } = massageUrlForAddon({
          url: toBeProcessedUrl,
          addOnRoute: addOnRoute,
        });

        if (addOnRoute === routeToScreenMap[navigationMenuNames.overview]) {
          history.replace(pathNames + search);
        } else {
          if (replaceRoute) history.replace(massagedUrl);
          else history.push(massagedUrl, routeData);
        }
        break;
      }

      case dayUseNavigationMenuNames.calendar:
        if (sourceOfTrigger && isValidRouteForCalendarAndTimeScreen(sourceOfTrigger)) {
          dispatch(updateCalendarProgressiveSearchFormOpenedBy(sourceOfTrigger));
          if (replaceRoute)
            history.replace(pathName + `hourly-calendar/` + location.search, routeData);
          else history.push(pathName + `hourly-calendar/` + location.search, routeData);
        }
        break;

      case dayUseNavigationMenuNames.checkinTime:
        if (sourceOfTrigger && isValidRouteForCalendarAndTimeScreen(sourceOfTrigger)) {
          dispatch(updateCalendarProgressiveSearchFormOpenedBy(sourceOfTrigger));
          if (replaceRoute)
            history.replace(pathName + `hourly-checkintime/` + location.search, routeData);
          else history.push(pathName + `hourly-checkintime/` + location.search, routeData);
        }
        break;

      case dayUseNavigationMenuNames.autosuggest:
        dispatch(resetNewCGFilterAction());
        if (sourceOfTrigger) dispatch(updateAutosuggestOpenedBy(sourceOfTrigger));
        const dayUseAutoSuggestUrl = pathName + `hourly-search/` + location.search;
        if (replaceRoute) history.replace(dayUseAutoSuggestUrl, routeData);
        else history.push(dayUseAutoSuggestUrl, routeData);
        break;

      case dayUseNavigationMenuNames.home:
        dispatch(resetNewCGFilterAction());
        const dayUseHomeUrl = Object.keys(queryParams).length
          ? `/hotels/hourly-booking-hotels/?${querystring.stringify(queryParams)}`
          : `/hotels/hourly-booking-hotels/`;

        if (replaceRoute) history.replace(dayUseHomeUrl, routeData);
        else history.push(dayUseHomeUrl, routeData);
        break;

      case dayUseNavigationMenuNames.srp:
        const {
          newFilterData: propNewFilterData,
          newLocationData: propNewLocationData,
          sort: propSort,
        } = customData || {};

        if (propNewLocationData) {
          dispatch(updateQueryAction({newLocationData: propNewLocationData}));
        }

        const {selectedSlot} = srpUnifConfig;

        const isDayUseUnif = checkDayUseSRPVersionUnif({
          isSeo: isDayuseSeoSrp,
          unified_hourly_listing_web: pokusExpData.unified_hourly_listing_web,
        });
        const {shouldEncode: isEncode} = customData || {};

        const filter = isDayUseUnif ? srpUnifConfig?.filter : dayuseSrpConfig?.filter || [];
        if (isDayuseSeoSrp || isDayuseUnifSeoSrp) {
          updateDayuseSeoViewMoreStatusCaller(false, false, false);
        }

        const dayuseData = {
          checkin: dayUseCheckinDate,
          roomString,
          destination,
          locus,
          country,
          partner,
          filter: filter,
          shouldEncode: isEncode,
          selectedRegionCity: {},
          checkinTime,
          searchText,
          newFilterData: propNewFilterData || newFilterData,
          newLocationData: propNewLocationData || newLocationData,
          sort: propSort || sortData,
          newSelectedSlot: selectedSlot,
          funnel: 'hourly',
        };

        const dayUseSrpRouteUrl = isNewHourlySrpFlow
          ? getNewUrl(dayuseData, 'hourlySrp')
          : getDayUseSrpRouteUrl(dayuseData);
        // need to update a condition here for whether to track to recent search
        // if hits coming from FilterScreen, need not track into recent search
        updateRecentSearch({
          destination,
          locus,
          checkin: dayUseCheckinDate,
          country,
          partner,
          roomString,
          isDayUse: true,
          checkinTime,
          url: dayUseSrpRouteUrl,
        });

        isPageHeaderSearchWidgetOpen && dispatch(updatePageHeaderSearchWidgetOpen(false)); // close search widget on in-app movement
        if (replaceRoute) history.replace(dayUseSrpRouteUrl);
        else history.push(dayUseSrpRouteUrl);
        break;

      case dayUseNavigationMenuNames.goSuggest:
        if (!(selectedHotel.propertyName && selectedHotel.propertyId)) {
          return null;
        }

        const dayUseGoSuggestRouteUrl = getDayUseGoSuggestRouteUrl({
          checkin: dayUseCheckinDate,
          roomString,
          destination,
          locus,
          checkinTime,
          overriderankvhids: propertyId,
          vendor: '',
          mmtId: selectedHotel?.mmtId,
          country,
        });
        // need to update a condition here for whether to track to recent search
        // if hits coming from FilterScreen, need not track into recent search
        let tempDestination = destination;
        if (selectedHotel?.mmtId) {
          tempDestination = {...destination, mmtId: selectedHotel?.mmtId};
        }
        updateRecentSearch({
          destination: tempDestination,
          locus,
          checkin: dayUseCheckinDate,
          country,
          partner,
          roomString,
          isDayUse: true,
          checkinTime,
          url: dayUseGoSuggestRouteUrl,
          hotelCode: propertyId,
          hotelName: propertyName,
        });

        isPageHeaderSearchWidgetOpen && dispatch(updatePageHeaderSearchWidgetOpen(false)); // close search widget on in-app movement
        if (replaceRoute) history.replace(dayUseGoSuggestRouteUrl);
        else history.push(dayUseGoSuggestRouteUrl);
        break;

      case dayUseNavigationMenuNames.detail:
        const {
          newFilterData: propFilterData,
          newLocationData: propLocationData,
          sort: propSortData,
        } = customData || {};
        const checkinJSDate = dayUseCheckinDate?.date;
        const selectedSlotDuration = routeData?.selectedSlot || null;
        const srpType = routeData?.srpType || '';
        const hotelPartner = partner;
        const cityName = destination.n || searchText;
        const mmtId = routeData?.mmtId || '';

        const detailsDayusePageMakingOptions = getArgsForDayuseDetailsUrlMake({
          selectedHotel,
          hotelPartner,
          checkinJSDate,
          checkinTime,
          roomString,
          locus,
          countryCode: country,
          cityName,
          metaPartner,
          selectedSlotDuration,
          srpType,
          newFilterData: propFilterData || newFilterData,
          newLocationData: propLocationData || newLocationData,
          sortData: propSortData || sortData,
          mmtId,
        });

        const detailsDayusePageMakingOptionsNew = {
          checkin: dayUseCheckinDate,
          checkinTime,
          searchText,
          roomString,
          destination,
          locus,
          cityName,
          partner: hotelPartner,
          country,
          metaPartner,
          newSelectedSlot: selectedSlotDuration,
          newFilterData: customData?.newFilterData || newFilterData,
          newLocationData: customData?.newLocationData || newLocationData,
          mmtId: selectedHotel?.mmtId,
          propertyName: selectedHotel?.propertyName,
          propertyId: selectedHotel?.propertyId,
        };

        if (!(selectedHotel.propertyName && selectedHotel.propertyId)) {
          return null;
        }
        isPageHeaderSearchWidgetOpen && dispatch(updatePageHeaderSearchWidgetOpen(false)); // close search widget on in-app movement
        const detailDayUsesUrl = isNewDetailsFlow
          ? getNewUrl(detailsDayusePageMakingOptionsNew, 'hourlyDetail')
          : getDayUseDetailsPageUrl(detailsDayusePageMakingOptions);
        if (replaceRoute) history.replace(detailDayUsesUrl, routeData);
        else history.push(detailDayUsesUrl, routeData);
        break;
      default:
        break;
    }
  };

  const getPageUrl = ({
    target,
    addOnRoute,
    sourceOfTrigger,
    params = {},
  }: {
    target: NavigateToArgType;
    addOnRoute?: AddOnRouteArgType;
    sourceOfTrigger?: 'similarhotels' | AutosuggestOpenedByPageType['page'];
    params?: Object;
  }) => {
    const state = store.getState();
    const commonState = commonSelector(state);
    const {
      checkin,
      checkout,
      roomString,
      destination,
      locus,
      country,
      partner,
      metaPartner,
      selectedHotel,
      newFilterData = '',
      newLocationData = '',
      sortData = '',
      topHtlId,
      sType,
    } = commonState;
    let url = '';
    switch (target) {
      case 'srp':
        const srpUrl = getSrpUrl({
          checkin,
          checkout,
          roomString,
          destination,
          locus,
          country,
          partner,
          filter: {},
          newFilterData,
          newLocationData,
          sort: sortData,
          mmtId: topHtlId,
          sType,
        });
        // need to update a condition here for whether to track to recent search
        // if hits coming from FilterScreen, need not track into recent search
        url = `${apiConfig.__GOIBIBO__}${srpUrl}`;
        break;

      case 'details': {
        const checkinJSDate = checkin.date;
        const checkoutJSDate = checkout.date;
        const hotelPartner = partner;
        const cityName = destination.n;
        const {selectedHotel: selectedHotelParam = {}} = params;

        if (!(selectedHotelParam?.propertyName && selectedHotelParam?.propertyId)) {
          return null;
        }

        const detailsPageMakingOptions = getArgsForDetailsUrlMake({
          selectedHotel: selectedHotelParam,
          hotelPartner,
          checkinJSDate,
          checkoutJSDate,
          roomString,
          countryCode: country,
          cityName,
          metaPartner,
          locus,
          destination,
          newFilterData,
          newLocationData,
          sortData,
          topHtlId,
          sType,
        });

        const detailsUrl = getDetailsPageUrl(detailsPageMakingOptions);

        url = `${apiConfig.__GOIBIBO__}${detailsUrl}`;
        break;
      }
      default:
        break;
    }
    return url;
  };
  return [navigateTo, getPageUrl];
};

export default useNavigator;
